<template>
  <div>
    <b-row class="match-height">
      <b-col
        xl="3"
        md="3"
        sm="6"
        v-show="$Can('view_roles_and_permissions_btn')"
      >
        <settings-card
          icon="ShieldIcon"
          statistic="Roles & Permissions"
          link="userrole"
          statistic-title="User Roles"
          color="success"
        />
      </b-col>

      <b-col xl="3" md="3" sm="6" v-show="$Can('view_pillars_btn')">
        <settings-card
          icon="ListIcon"
          statistic="Pillars"
          link="pillars"
          statistic-title="Pillars"
          color="primary"
        />
      </b-col>

      <b-col xl="3" md="3" sm="6" v-show="$Can('view_pillar_title_btn')">
        <settings-card
          icon="LayersIcon"
          statistic="Pillar Titles"
          link="pillar-titles"
          statistic-title="Pillar Titles"
          color="warning"
        />
      </b-col>

      <b-col xl="3" md="3" sm="6" v-show="$Can('view_objective_btn')">
        <settings-card
          icon="LayersIcon"
          statistic="Objective"
          link="objectives"
          statistic-title="Objectives"
          color="secondary"
        />
      </b-col>

      <b-col xl="3" md="3" sm="6" v-show="$Can('view_action_btn')">
        <settings-card
          icon="LayersIcon"
          statistic="Actions"
          link="actions"
          statistic-title="Actions"
          color="primary"
        />
      </b-col>

      <b-col xl="3" md="3" sm="6" v-show="$Can('view_kpi_btn')">
        <settings-card
          icon="LayersIcon"
          statistic="KPI"
          link="kpis"
          statistic-title="KPIs"
          color="danger"
        />
      </b-col>

      <!-- <b-col xl="3" md="3" sm="6" v-show="$Can('view_narrative_btn')">
        <settings-card
          icon="LayersIcon"
          statistic="Narrative"
          link="narratives"
          statistic-title="Narratives"
          color="warning"
        />
      </b-col> -->

      <b-col xl="3" md="3" sm="6" v-show="$Can('view_working_group_btn')">
        <settings-card
          icon="LayersIcon"
          statistic="Working Groups"
          link="working-groups"
          statistic-title="Working Groups"
          color="success"
        />
      </b-col>

      <b-col xl="3" md="3" sm="6" v-show="$Can('view_owner_btn')">
        <settings-card
          icon="LayersIcon"
          statistic="Owner"
          link="owners"
          statistic-title="owners"
          color="secondary"
        />
      </b-col>

      <b-col xl="3" md="3" sm="6" v-show="$Can('view_prority_btn')">
        <settings-card
          icon="LayersIcon"
          statistic="Priorities"
          link="priorities"
          statistic-title="priorities"
          color="danger"
        />
      </b-col>

      <b-col xl="3" md="3" sm="6" v-show="$Can('view_company_btn')">
        <settings-card
          icon="HomeIcon"
          statistic="Company"
          link="companies"
          statistic-title="Company"
          color="warning"
        />
      </b-col>
         <b-col xl="3" md="3" sm="6" v-show="$Can('view_site_btn')">
        <settings-card
          icon="LayersIcon"
          statistic="Site"
          link="sites"
          statistic-title="Site"
          color="warning"
        />
      </b-col>


      <b-col xl="3" md="3" sm="6">
        <settings-card
          icon="BookOpenIcon"
          statistic="Courses"
          link="courses"
          statistic-title="Courses"
          color="primary"
        />
      </b-col>

      <b-col xl="3" md="3" sm="6">
        <settings-card
          icon="MapPinIcon"
          statistic="Venues"
          link="venues"
          statistic-title="Venues"
          color="info"
        />
      </b-col>

      <b-col xl="3" md="3" sm="6">
        <settings-card
          icon="UserIcon"
          statistic="Trainers"
          link="trainers"
          statistic-title="Trainers"
          color="success"
        />
      </b-col>

      <b-col xl="3" md="3" sm="6" v-show="$Can('view_timeline_actions')">
        <settings-card
          icon="ActivityIcon"
          statistic="Actions Timeline"
          link="actions-timeline"
          statistic-title="Actions Timeline"
          color="danger"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BFormGroup,
  BTable,
  BRow,
  BCol,
  BFormSelect,
  BPagination,
} from "bootstrap-vue";

import useUserList from "./useSettings";

import store from "@/store";
import { avatarText } from "@core/utils/filter";
import { onUnmounted } from "@vue/composition-api";
import settingsStoreModule from "./settingsStoreModule";
import SettingsCard from "@core/components/statistics-cards/SettingsCard.vue";
export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BTable,
    BFormSelect,
    BPagination,

    SettingsCard,
  },

  methods: {},

  setup() {
    const SETTINGS_APP_STORE_MODULE_NAME = "settings";
    // Register module
    if (!store.hasModule(SETTINGS_APP_STORE_MODULE_NAME))
      store.registerModule(SETTINGS_APP_STORE_MODULE_NAME, settingsStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(SETTINGS_APP_STORE_MODULE_NAME))
        store.unregisterModule(SETTINGS_APP_STORE_MODULE_NAME);
    });

    const { loading } = useUserList();

    return {
      loading,
      // Filter
    };
  },
  mounted() {},
};
</script>
